import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import Pagination from "../../components/Pagination/Pagination";
import Table from "../../components/Table/Table";
import AllLessonPlansFilter from "./AllLessonPlansFilter";
import { allLessonPlansTableConstants } from "./AllLessonPlansTableConst";
import { useAllLessonPlans } from "./hooks/useAllLessonPlans";
import { useLessonPlanFilterOptions } from "./hooks/useLessonPlanFilterOptions";
import { ALL_PLANS_PER_PAGE } from "./LessonPlannerConstant";

/** Every teacher's lesson plans — shown only with lesson_plan.view_all. */
const AllLessonPlansView = () => {
  const navigate = useNavigate();
  const {
    lessons,
    filters,
    isLoading,
    lastPage,
    currentPage,
    totalRecords,
    fetchLessons,
    handleFilterChange,
    handleSearch,
    handleReset,
    handlePageChange,
  } = useAllLessonPlans();

  const { teacherOptions, programOptions, subjectOptions } = useLessonPlanFilterOptions(filters.program_id);

  useEffect(() => {
    fetchLessons(1);
  }, [fetchLessons]);

  // Row index lets the S.No column continue across pages
  const rows = useMemo(() => lessons.map((lesson, rowIndex) => ({ ...lesson, rowIndex })), [lessons]);

  return (
    <>
      <AllLessonPlansFilter
        filters={filters}
        teacherOptions={teacherOptions}
        programOptions={programOptions}
        subjectOptions={subjectOptions}
        onFilterChange={handleFilterChange}
        onSearch={handleSearch}
        onReset={handleReset}
      />

      {!isLoading && <p className="text-muted small mb-2">{totalRecords} lesson plans found</p>}
      {isLoading && <Loader />}

      <div className="evaluating-table event-tablecus">
        <Table
          cols={allLessonPlansTableConstants(
            (lesson) => navigate(`/lesson-planner/view/${lesson.id}`),
            currentPage * ALL_PLANS_PER_PAGE,
          )}
          data={rows}
          hoverable
          striped
        />
      </div>

      {lastPage > 1 && (
        <Pagination totalPage={lastPage} currentPage={currentPage} handlePageChange={handlePageChange} />
      )}
    </>
  );
};

export default AllLessonPlansView;
